

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.abd7be30.js","_app/immutable/chunks/scheduler.349e619f.js","_app/immutable/chunks/index.b97ce8f1.js","_app/immutable/chunks/singletons.56035e1e.js","_app/immutable/chunks/index.e9bbedad.js"];
export const stylesheets = [];
export const fonts = [];
